import { render, staticRenderFns } from "./radioType.vue?vue&type=template&id=b4ae444a&scoped=true"
import script from "./radioType.vue?vue&type=script&lang=js"
export * from "./radioType.vue?vue&type=script&lang=js"
import style0 from "./radioType.vue?vue&type=style&index=0&id=b4ae444a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ae444a",
  null
  
)

export default component.exports